import { render } from "./ReportForm.vue?vue&type=template&id=5b2b3c32"
import script from "./ReportForm.vue?vue&type=script&lang=js"
export * from "./ReportForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__